import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/availability_center'

export default {
  getRegions (baseUrl, name) {
    return axios.get(baseUrl + URL + '/filter?name=' + name ).then((response) => {
      return response
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  fetchCenter (baseUrl) {
    return axios.get(baseUrl + URL + '/get').then((response) => {
      return common.prepareThen(response).data
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
